/* eslint-disable */
const hostname = window.location.hostname;

const getObject = ({WealthServices, activaUrl, MockServer, BCDocumentAPI}) => ({
    API: {
        WealthServices,
        activaUrl,
        MockServer,
        BCDocumentAPI,
    },
});

const activa = {
    API_NAME: "mfe-activa-web-cl",
    ENV: "uat",
    DOMAIN: "apps.stg.azr-cc-pcf.cloud.bns",
    ROUTE: "sweb/mfe/mfe-activa-web-cl",
};

let {API_NAME, ENV, DOMAIN, ROUTE} = activa;

export const resolveEnvConfig = (envKey) => {
    switch (envKey) {
        case "mock":
            return getObject({
                WealthServices: `/api/wealth`,
                activaUrl: `https://banco.${envKey}.npe-k8s.chl.bns/mfe/clservices/mfe-activa-web-cl`,
                BCDocumentAPI: `bc-requests-sales-uat.apps.stg.azr-cc-pcf.cloud.bns/v1`,
                MockServer: true,
            });
        case "ist-ia4":
        case "ist-ia9":
        case "uat-pa5":
            return getObject({
                WealthServices: `https://banco.${envKey}.npe-k8s.chl.bns/api/clsales/ce-wealth-customer-web`,
                BCDocumentAPI: `https://bc-requests-sales.clsales.${envKey}.npe-k8s.chl.bns/v1`,
                activaUrl: `https://banco.${envKey}.npe-k8s.chl.bns/mfe/clservices/mfe-activa-web-cl`,
                MockServer: false,
            });
        case "banco.scotiabank.cl":
            return getObject({
                WealthServices: `https://banco.k8s.chl.bns/api/clsales/ce-wealth-customer-web`,
                BCDocumentAPI: `https://bc-requests-sales.clsales.k8s.chl.bns/v1`,
                activaUrl: `https://banco.scotiabank.cl/mfe/clservices/mfe-activa-web-cl`,
                MockServer: false,
            });
        default:
            return getObject({
                WealthServices: `https://banco.uat-pa5.npe-k8s.chl.bns/api/clsales/ce-wealth-customer-web`,
                BCDocumentAPI: `https://bc-requests-sales.clsales.uat-pa5.npe-k8s.chl.bns/v1`,
                activaUrl: `https://banco.uat-pa5.npe-k8s.chl.bns/mfe/clservices/mfe-activa-web-cl`,
                MockServer: false,
            });
    }
};

let enviroment;
let CONFIG;
debugger
if (hostname === "localhost") {
    enviroment = "uat-pa5";
} else {
    [enviroment] = hostname.match(/ist-ia4|ist-ia9|uat-pa5|banco.scotiabank.cl/) || [];
}

//Descomentar esto para usar los mocks:
CONFIG = resolveEnvConfig(enviroment);
//CONFIG = resolveEnvConfig("mock");
export default CONFIG;
